import { Screen } from "@/components";

export default function TVSpaceNavigationScreen() {
  return <Screen title="react-tv-space-navigation" />;
}
